module.exports = __webpack_public_path__ + "static/media/havilla_gift_header_image.2db1e369.png";